module.exports = __webpack_public_path__ + "img/cashier2.d3fc67a7.png";